<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "AccidentIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
